export const useApiData = <TData, TOptions>(
    fetchDataCallback: (opt?: TOptions) => Promise<{ isSuccess: boolean; data: TData | null }>,
    fetchOpt?: TOptions
) => {
    const {
        isLoading,
        data,
        request: requestArgs,
    } = useApiDataWithArgs<null, TData, TOptions>((_, opt) => fetchDataCallback(opt), fetchOpt);

    const request = async (opt?: TOptions, delay?: number) => {
        return await requestArgs(null, opt, delay);
    };

    return {
        data,
        isLoading,
        request,
    };
};

export const useApiDataWithArgs = <TArgs, TData, TOptions>(
    fetchDataCallback: (args: TArgs, opt?: TOptions) => Promise<{ isSuccess: boolean; data: TData | null }>,
    fetchOpt?: TOptions
) => {
    const isSuccess = ref(false);
    const data = ref<TData | null>();

    const { isLoading, execute } = useAsyncState(
        async (args: TArgs, opt?: TOptions) => {
            const res = await fetchDataCallback(args, opt);

            isSuccess.value = res.isSuccess;
            data.value = res.data;

            return res;
        },
        { isSuccess: false, data: null },
        {
            immediate: false,
        }
    );

    const request = async (
        args: TArgs,
        opt?: TOptions,
        delay?: number
    ): Promise<{ isSuccess: boolean; data: TData | null }> => {
        return await execute(delay, args, opt || fetchOpt);
    };

    return {
        isSuccess,
        data,
        isLoading,
        request,
    };
};
